import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var FastForward = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.49 21.77 22.73 1.018c-.3-.3-.799-.4-1.098-.2-.4.2-.6.599-.6.998v17.957L2.067.82C1.667.419 1.268.32.868.519c-.399.1-.598.5-.598.899v41.501c0 .4.2.799.598.998.4.2.799.1 1.098-.2l18.966-18.955v18.556c0 .4.2.799.599.998.399.2.798.1 1.098-.2l20.762-20.75c.2-.2.3-.5.3-.699.1-.399 0-.698-.2-.898ZM2.267 40.424V3.912l18.267 18.257L2.266 40.425Zm20.762.4V4.31l18.267 18.256-18.267 18.257Z"
  }));
});
FastForward.displayName = 'FastForward';
FastForward.defaultProps = {
  'aria-label': 'FastForward'
};
export default FastForward;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/FastForward.js
// module id = 3155
// module chunks = 11